import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface RecycleMember {
  id: number; type: 'reservation'; identifier: string; deleted_at: string; deleted_by_name: string;
  reason: string | null; scheduled_deletion_at: string; days_remaining: number; restorable: boolean;
}

export interface RecycleItem {
  id: number; type: 'space' | 'reservation' | 'customer'; name: string; identifier: string;
  business_name: string; deleted_at: string; deleted_by_name: string; reason: string | null;
  scheduled_deletion_at: string; days_remaining: number; restorable: boolean;
  /** Solo en type:'reservation' -- un conjunto multi-fecha reciclado de una sola vez. */
  is_group?: boolean; group_key?: string; members?: RecycleMember[];
}

export interface RecycleListFilters {
  business_id: number;
  page: number;
  limit: number;
  search?: string;
  type?: '' | RecycleItem['type'];
  from?: string;
  to?: string;
}

@Injectable({ providedIn: 'root' })
export class RecycleService {
  private readonly url = `${environment.apiUrl}/recycle`;
  constructor(private http: HttpClient) {}
  list(filters: RecycleListFilters): Observable<{ total: number; pages: number; data: RecycleItem[] }> {
    let params = new HttpParams(); Object.entries(filters).forEach(([key, value]) => { if (value !== '' && value !== null && value !== undefined) params = params.set(key, String(value)); });
    return this.http.get<{ total: number; pages: number; data: RecycleItem[] }>(this.url, { params });
  }
  restore(type: string, id: number) { return this.http.post(`${this.url}/${type}/${id}/restore`, {}); }
  permanentDelete(type: string, id: number, reason: string) { return this.http.delete(`${this.url}/${type}/${id}/permanent`, { body: { reason } }); }
}
